import React, { useContext, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import moment from "moment";
import axios from "axios";
import { API_URL } from "../../utilities/url";
import { FiEye, FiPlus } from "react-icons/fi";
import { Button, Form } from "react-bootstrap";
import storage from "../../services/storage";
import ChatbotChart from "./component/chatbotChart";
import ChatbotPanel from "./component/chatbotPanel";
import CryptoJS from "crypto-js";
import { FaCog, FaTrash } from "react-icons/fa";
import { WorkspaceContext } from "../../provider/workspaceContext";
import { BsChatLeftTextFill } from "react-icons/bs";
import { PiChartLineUpBold } from "react-icons/pi";
import { RiChatNewLine } from "react-icons/ri";

var $ = require("jquery");

const Chatbot = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { workspace } = useContext(WorkspaceContext);
  const [activeFilter, setActiveFilter] = useState("Semua");
  // Ref tracks the current filter so the DataTable's ajax.data closure
  // always reads the latest value (the closure is captured at init time).
  const activeFilterRef = useRef("Semua");
  const handleFilterClick = (filter) => {
    activeFilterRef.current = filter;
    setActiveFilter(filter);
  };

  const statusFilterParam = (filter) => {
    if (filter === "Active") return "active";
    if (filter === "Monitor") return "monitor";
    if (filter === "Non-Active") return "inactive";
    return "all";
  };

  const toggleChatbotStatus = (idt_osa, nextStatus) => {
    axios
      .post(
        `${API_URL}toggle-chatbot-status`,
        { idt_osa, status: nextStatus },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          const statusMsg =
            nextStatus === "active"
              ? "Chatbot activated"
              : nextStatus === "monitor"
              ? "Chatbot set to monitor (analyze only, no auto-reply)"
              : "Chatbot deactivated";
          toast.success(statusMsg, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 3000,
            hideProgressBar: true,
          });
          if ($.fn.DataTable.isDataTable("#datatables-reponsive")) {
            $("#datatables-reponsive").DataTable().ajax.reload(null, false);
          }
        } else {
          toast.error(response.data.message || "Failed to update status", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      })
      .catch(() => {
        toast.error("Failed to update status", {
          position: "top-right",
          theme: "colored",
          transition: Slide,
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  };

  useEffect(() => {
    if (localStorage.getItem("alert")) {
      toast.success("Success Create OSA Chatbot!", {
        position: "top-right",
        theme: "colored",
        transition: Slide,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
      });
      localStorage.removeItem("alert");
    } else if (localStorage.getItem("alertu")) {
      toast.success("Success Update OSA Chatbot!", {
        position: "top-right",
        theme: "colored",
        transition: Slide,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
      });
      localStorage.removeItem("alertu");
    }

    $("#datatables-reponsive").DataTable({
      dom:
        "<'row'<'col-sm-6'l><'col-sm-6'B>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      processing: true,
      serverSide: true,
      bDestroy: true,
      ajax: {
        url: API_URL + "list-table-chatbot",
        data: function (data) {
          data.idt_user_workspace = workspace.idt_user_workspace;
          data.status_filter = statusFilterParam(activeFilterRef.current);
        },
        type: "post",
        headers: {
          Authorization: `Bearer ${storage.get("access_token")}`,
        },
        error: function (xhr, error, code) {},
      },
      order: [[0, "desc"]],
      columnDefs: [
        {
          targets: [3],
          createdCell: function (td) {
            td.classList.add("dt-right");
          },
        },
        {
          targets: [4],
          createdCell: function (td) {
            td.classList.add("dt-center");
          },
        },
        {
          className: "dt-center",
          targets: 5,
          createdCell: (td, cellData, rowData) => {
            const current = rowData.status || "inactive";
            ReactDOM.render(
              <div
                className="d-flex justify-content-center align-items-center"
                title="Active: auto-replies · Monitor: analyze only, no auto-reply · Off: ignored"
              >
                <Form.Select
                  size="sm"
                  id={`chatbot-status-${rowData.idt_osa}`}
                  value={current}
                  onChange={(e) =>
                    toggleChatbotStatus(rowData.idt_osa, e.target.value)
                  }
                  style={{ cursor: "pointer", width: "auto", minWidth: "110px" }}
                >
                  <option value="active">Active</option>
                  <option value="monitor">Monitor</option>
                  <option value="inactive">Off</option>
                </Form.Select>
              </div>,
              td
            );
          },
        },
        {
          className: "dt-center",
          targets: 6,
          createdCell: (td, cellData, rowData, row, col) =>
            ReactDOM.render(
              <div className="d-grid gap-2 d-md-flex justify-content-center align-items-center">
                <a
                  onClick={() => showLivechat(cellData)}
                  className="btn btn-sm btn-success btn-rounded"
                  title="Webchat View"
                >
                  <BsChatLeftTextFill size={14} />
                </a>
                <a
                  onClick={() =>
                    navigate(
                      "/chatbot/report-analysis/" +
                        CryptoJS.AES.encrypt(JSON.stringify(cellData), "wrs")
                          .toString()
                          .replace(/\//g, "_")
                    )
                  }
                  className="btn btn-sm btn-primary btn-rounded"
                  title="Report & Analysis"
                >
                  <PiChartLineUpBold size={16} />
                </a>
                {/* <a
                  onClick={() => deleteTable(cellData)}
                  className="btn btn-sm btn-danger btn-rounded"
                  title="Delete"
                >
                  <FaTrash />
                </a> */}
                <a
                  onClick={() =>
                    navigate(
                      "/chatbot/detail/" +
                        CryptoJS.AES.encrypt(JSON.stringify(cellData), "wrs")
                          .toString()
                          .replace(/\//g, "_")
                    )
                  }
                  className="btn btn-sm btn-warning btn-rounded"
                  title="Settings"
                >
                  <FaCog size={14} />
                </a>
              </div>,
              td
            ),
        },
      ],
      columns: [
        {
          data: "ts_created",
          render: function (data, type, row) {
            var data = moment(data).format("DD-MM-YYYY");

            return data;
          },
        },
        { data: "chatbot_name" },
        {
          data: "devices",
          render: function (data, type, row) {
            if (!data) return "-"; // Jika data kosong, tampilkan tanda "-"

            return data
              .split(",")
              .map(
                (item) =>
                  `<span class="badge bg-info py-1 px-2 me-1">${item.trim()}</span>`
              )
              .join("");
          },
        },
        { data: "workspace_member_count" },
        {
          data: "subscription_type",
          render: function (data, type, row) {
            if (data === "paid") {
              var data = `<span class="badge bg-success py-1 px-2">Paid</span>`;
            } else {
              var data = `<span class="badge bg-info py-1 px-2">Free</span>`;
            }

            return data;
          },
        },
        { data: "status", defaultContent: "" },
        { data: "idt_osa" },
      ],
      initComplete: function () {
        var api = this.api();
        $("#search")
          .off(".DT")
          .on("keyup.DT", function (e) {
            api.search(this.value).draw();
          });
      },
    });
  }, [location.key]);

  // Reload the table when the Semua / Active / Non-Active tab changes
  // so the new status_filter is sent without rebuilding the DataTable.
  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#datatables-reponsive")) {
      $("#datatables-reponsive").DataTable().ajax.reload(null, false);
    }
  }, [activeFilter]);

  const showLivechat = (id) => {
    navigate("/chat", { state: { chatbotId: id } });
  };

  return (
    <div className="container-fluid p-0">
      <ChatbotPanel />
      <ChatbotChart />
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <div className="d-flex justify-content-between mb-3">
                <div>
                  <h5 className="card-title mt-2">OSA Chatbot Services</h5>
                  <ToastContainer />
                </div>
              </div>
              <div className="row">
                <div className="d-flex justify-content-between mt-2 mb-0">
                  {/* Filter Buttons */}
                  <div>
                    {["Semua", "Active", "Monitor", "Non-Active"].map((filter) => (
                      <Button
                        key={filter}
                        variant={activeFilter === filter ? "orange-2" : "light"}
                        className={`me-2 ${
                          activeFilter === filter ? "text-white" : ""
                        }`}
                        onClick={() => handleFilterClick(filter)}
                      >
                        {filter}
                      </Button>
                    ))}
                  </div>
                  <div>
                    <Link to="/chatbot/add" className="btn btn-md btn-primary">
                      <RiChatNewLine size={20} className="me-2" />
                      <span>Create Chatbot</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body ">
              <div className="table-responsive">
                <table
                  id="datatables-reponsive"
                  className="table table-striped table-bordered table-custome"
                >
                  <thead>
                    <tr className="text-white">
                      <th>Date</th>
                      <th>Service Name</th>
                      <th>Device Name</th>
                      <th>Total Operator</th>
                      <th>Type Service</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
